module.exports = __webpack_public_path__ + "static/fg-2f8488c3ba88767266923014f33af008.png";